export enum ProgressTypeEnum {
    Document = 'document',
    Assignment = 'assignment',
    Algebrakit = 'algebrakit',
    Drillster = 'drillster',
    Exam = 'exam',
    Remindo = 'remindo',
    RemindoExam = 'remindo-exam',
}
